// extracted by mini-css-extract-plugin
export default {"topicHeader":"topic_topicHeader__lz5h9","title":"topic_title__8ZSZI","accordion":"topic_accordion__YG3cP","selected":"topic_selected__ocOxU","divider":"topic_divider__kIA-Y"};